import React from "react";
export default function Footer({backgroundColor = false}){
    return(
        <footer className="footer" style={{backgroundColor:backgroundColor?backgroundColor:undefined}}>
            <p>
                &copy; Copyright 2023 - Afif.ai
            </p>
        </footer>
    )
}